import styled from "styled-components";

export const AppWrapper = styled.div`
  text-align: center;
  margin: 0 auto;
  font-weight: 200;
  letter-spacing: 0.05rem;
  padding-bottom: 3em;
  max-width: 1440px;
`;
